import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
	makeStyles
} from "@material-ui/core";

import api from "../../services/api";
import { prioridadeDe } from "../../utils/mural";

const INTERVALO_MS = 10 * 60 * 1000;

const useStyles = makeStyles(theme => ({
	item: {
		paddingLeft: 0
	},
	icone: {
		minWidth: 34
	}
}));

/*
 * Cobranca de ciencia.
 * =============================================================
 * Aparece na entrada e volta a cada dez minutos enquanto houver aviso
 * obrigatorio sem confirmacao. E interno ao RSDESK: nao manda WhatsApp,
 * nao manda e-mail, nao toca em contato nenhum.
 *
 * Um modal por vez, e nunca por cima de outro: o estado `aberto` so vira
 * verdadeiro quando nada mais esta aberto. Dois avisos empilhados fariam
 * a pessoa fechar os dois no reflexo, sem ler nenhum — que e justamente o
 * contrario do que a cobranca existe para conseguir.
 *
 * O relogio conta a partir do fechamento, nao da abertura da tela: quem
 * acabou de dispensar merece dez minutos de trabalho antes da proxima
 * interrupcao.
 * =============================================================
 */
const PendingAnnouncementsAlert = ({ ativo = true, bloqueado = false }) => {
	const classes = useStyles();
	const history = useHistory();
	const [pendentes, setPendentes] = useState([]);
	const [aberto, setAberto] = useState(false);
	const proximaCobranca = useRef(0);

	const consultar = useCallback(async () => {
		if (!ativo) return;

		try {
			const { data } = await api.get("/announcements/pending");
			setPendentes(data.avisos || []);

			if (!data.total) return;
			if (bloqueado) return;
			if (Date.now() < proximaCobranca.current) return;

			setAberto(true);
		} catch (err) {
			// Silencio proposital: falha ao consultar pendencia nao pode
			// encher a tela de erro vermelho no meio de um atendimento.
		}
	}, [ativo, bloqueado]);

	useEffect(() => {
		consultar();
		const relogio = setInterval(consultar, 60 * 1000);
		return () => clearInterval(relogio);
	}, [consultar]);

	const fechar = () => {
		proximaCobranca.current = Date.now() + INTERVALO_MS;
		setAberto(false);
	};

	const verAvisos = () => {
		fechar();
		history.push("/");
	};

	if (!pendentes.length) return null;

	return (
		<Dialog open={aberto} onClose={fechar} maxWidth="xs" fullWidth>
			<DialogTitle>
				{pendentes.length === 1
					? "Voce tem 1 aviso pendente de ciencia."
					: `Voce tem ${pendentes.length} avisos pendentes de ciencia.`}
			</DialogTitle>

			<DialogContent dividers>
				<List dense disablePadding>
					{pendentes.slice(0, 6).map(aviso => {
						const prioridade = prioridadeDe(aviso.priority);
						const Icone = prioridade.Icone;

						return (
							<ListItem key={aviso.id} className={classes.item} disableGutters>
								<ListItemIcon className={classes.icone}>
									<Icone style={{ color: prioridade.cor }} />
								</ListItemIcon>
								<ListItemText
									primary={aviso.title}
									secondary={prioridade.rotulo}
								/>
							</ListItem>
						);
					})}
				</List>

				{pendentes.length > 6 && (
					<Typography variant="caption" color="textSecondary">
						e mais {pendentes.length - 6}...
					</Typography>
				)}
			</DialogContent>

			<DialogActions>
				<Button onClick={fechar}>Depois</Button>
				<Button color="primary" variant="contained" onClick={verAvisos}>
					Ver avisos
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PendingAnnouncementsAlert;
